import {Component} from '@angular/core';
import {ModalController, NavParams} from '@ionic/angular';

@Component({
    selector: 'emc-data-modal',
    template: `
            <ion-content>
                <div style="padding: 1em;">
                    <div *ngFor="let k of valueKeys" style="padding: 1em;">
                        <span *ngIf="!isObject(value[k])"><ion-label color="primary">{{k}}</ion-label>: {{value[k]}}</span>
                        <div *ngIf="isObject(value[k])">
                            <ion-label color="primary">{{k}}</ion-label>:
                            <div style="padding-left: 1em;" [innerHTML]="dataObjectToRows(value[k])"></div>
                        </div>
                    </div>
                </div>
            </ion-content>
    `
})
export class DataModalComponent {

    value: any;
    valueKeys;

    constructor(public viewCtrl: ModalController, params: NavParams) {
        this.value = params.get('value');
        this.valueKeys = Object.keys(this.value);
    }

    dismiss() {
        this.viewCtrl.dismiss();
    }

    isObject(value) {
        return typeof value === 'object';
    }

    dataObjectToRows(value) {
        let rows = '';
        Object.keys(value).forEach(k => {
            // tslint:disable-next-line:max-line-length
            rows += `<p style="padding: 1em;"><b>${k}</b>: ${this.isObject(value[k]) ? this.dataObjectToRows(value[k]) : value[k]}</p>`;
        });
    return rows;
}
}
